import { setTimedInterval } from "@sky-it-livedata-libraries/livedata-commons";

export const analyticsTrack = async (key: string, objKey?: string, value?: string): Promise<boolean> => {
  /**
   * ANALYTICS TRACKING relays on the presence of external "_satellite()" function
   * Loaded from CDN https://assets.adobedtm.com/launch-EN578e54a3f0c6478aa41c89022e30863c.min.js inside DIV ID "dtm_script"
   * TS doesn't know of its existence, so...
   */
  // console.log('[analytics-track.ts] LMP analyticsTrack', { key, value });
  // @ts-ignore for _satellite.track() (loaded from external lib inside AEM template)
  const satellite = window._satellite;
  const fn: Function = value ? () => satellite.track(key, { [objKey || 'value']: value }) : () => satellite.track(key);
  return setTimedInterval(fn, `'key=${key}, ${objKey || 'value'}=${value}'`);
};